import script from "./StartCountDown.vue?vue&type=script&setup=true&lang=ts"
export * from "./StartCountDown.vue?vue&type=script&setup=true&lang=ts"

import "./StartCountDown.vue?vue&type=style&index=0&id=8bccb87a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bccb87a"]])

export default __exports__